export default {"src":"/_next/static/media/armor_cat_ic.e4ff5410.svg","height":120,"width":120};